import React, { MouseEventHandler } from 'react';
import classNames from 'classnames';
import styles from './BottomNav.module.scss';
import { Capacitor } from '@capacitor/core';

export interface BottomNavButtonProps {
  label?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  active?: boolean;
  icon?: string;
}

export const BottomNavButton = ({ onClick, label, active = false, icon }: BottomNavButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={classNames(styles.button, {
        [styles.inverted]: active,
        [styles.buttonIos]: Capacitor.getPlatform() === 'ios'
      })}>
      <span className={styles.content}>
        {icon && (
          <span className={styles.icon}>
            <nbx-icon icon={icon} />
          </span>
        )}
        {label && <span>{label}</span>}
      </span>
    </button>
  );
};
